import { useRef } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { useButton } from 'react-aria';

import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './PrevPage.module.scss';

const PrevPage = props => {
    const intl = useIntl();
    const ref = useRef();
    const { buttonProps } = useButton({
        ...props,
        elementType: 'a'
    }, ref);

    return (
        <div
            {...buttonProps}
            className={['govuk-pagination__prev', styles.item].join(' ')}
        >
            <a
                className={['govuk-link govuk-pagination__link', styles.link].join(' ')}
                rel="prev"
            >
                <svg className="govuk-pagination__icon govuk-pagination__icon--prev"
                    xmlns="http://www.w3.org/2000/svg" height="13" width="15" aria-hidden="true"
                    focusable="false" viewBox="0 0 15 13">
                    <path
                        d="m6.5938-0.0078125-6.7266 6.7266 6.7441 6.4062 1.377-1.449-4.1856-3.9768h12.896v-2h-12.984l4.2931-4.293-1.414-1.414z"></path>
                </svg>
                <span className="govuk-pagination__link-title">
                    {intl.formatMessage({ id: 'pagination.previous' })}
                    <span className="govuk-visually-hidden">
                        {intl.formatMessage({ id: 'pagination.page' })}
                    </span>
                </span>
            </a>
        </div>
    );
};

PrevPage.propTypes = {
    ...defaultAriaProps,
    onPress: PropTypes.func
};

export default PrevPage;
